import { getFileVerification } from '@/services/fileUploadService'
import { uploadFileService } from '@/services/salesTargets'
import { useState } from 'react'

export const useFileUpload = () => {
  const [isUpdating, setUpdating] = useState(false)
  const [progress, setProgress] = useState(0)
  const [fileUploadError, setFileUploadError] = useState('')

  const onUploadProgress = progressEvent => {
    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    setProgress(progress)
  }

  const onUploadFile = (file, onCallback, params = {}) => {
    const formData = new FormData()
    const { fileType } = params
    formData.append('file', file)
    if (!fileType) {
      setFileUploadError('Upload Error')
      return
    }
    formData.append('fileType', fileType)

    setUpdating(true)
    uploadFileService({ formData, onUploadProgress })
      .then(response => {
        onCallback(response)
        setUpdating(false)
        setProgress(0)
        setFileUploadError('')
      })
      .catch(error => {
        const errMsg = error?.response?.data?.errorMessage || error?.message || 'An unknown error occurred'
        setUpdating(false)
        setProgress(0)
        setFileUploadError(errMsg)
      })
  }

  const uploadFile = async (file, uploadFor, fileType) => {
    const formData = new FormData()
    formData.append('file', file)
    return await getFileVerification(formData, uploadFor, onUploadProgress,fileType)
  }

  return {
    onUploadFile,
    isUpdating,
    progress,
    fileUploadError,
    onUploadProgress,
    setFileUploadError,
    uploadFile,
  }
}
